import { ReactNode } from 'react';
import styled from '@emotion/styled';
import { Theme } from '@mui/material';
import GlobalStyles from "@mui/material/GlobalStyles";

import Menu from 'components/views/Menu';
import NavSubPage from 'components/views/NavSubPage';
import ContainerSubPage from 'components/views/ContainerSubPage';

type Params = {
    title?: string;
    link?: string;
    typePage: 'page' | 'subpage' | 'quotation';
    children: ReactNode;
    isWebView: boolean;
    stepActive?: 0 | 1 | 2 | 3 | 4 | false;
    showShoppingCart?: boolean;
}

const ContainerBody = styled.div(
    ({ theme }: { theme?: Theme }) => `
    width: 100%;
    display: flex;
    height: 100vh;
    overflow: auto;
    padding: 1.25rem 1rem;
    flex-direction: column;

    @media(min-width: ${theme?.breakpoints.values.md}px) {
        flex-direction: row;
        justify-content: space-between;
    }
`);

const ParseWebView = ({ title = '', link = '', typePage, children, isWebView, stepActive, showShoppingCart }: Params) => {

    const handleSwitchDefault = (typePage: 'page' | 'subpage' | 'quotation') => {
        switch (typePage) {
            case 'page':
                return (
                    <Menu titlePage={title}>
                        {children}
                    </Menu >
                );
            case 'subpage':
                return (
                    <ContainerSubPage title={title} link={link} isWebView={isWebView}>
                        {children}
                    </ContainerSubPage>
                );
            case 'quotation':
                return (
                    <ContainerSubPage stepActive={stepActive} showShoppingCart={showShoppingCart} isWebView={isWebView}>
                        {children}
                    </ContainerSubPage>
                );
        }
    };

    const handleSwitchWebView = (typePage: 'page' | 'subpage' | 'quotation') => {
        switch (typePage) {
            case 'page':
                return (
                    <ContainerBody>
                        {title && <NavSubPage title={title} link={link} />}
                        {children}
                    </ContainerBody>
                );
            case 'subpage':
                return (
                    <ContainerSubPage title={title} link={link} isWebView={isWebView}>
                        {children}
                    </ContainerSubPage>
                );
            case 'quotation':
                return (
                    <ContainerSubPage stepActive={stepActive} showShoppingCart={showShoppingCart} isWebView={isWebView}>
                        {children}
                    </ContainerSubPage>
                );
        }
    };

    return (
        <>
            <GlobalStyles
                styles={{
                    'iframe[title="Mensagem da empresa"]': {
                        display: 'none !important',
                        opacity: '0 !important'
                    },
                    'iframe[title = "Fechar mensagem"]': {
                        display: 'none !important',
                        opacity: '0 !important'
                    },
                    'iframe[title="Close message"]': {
                        display: 'none !important',
                        opacity: '0 !important'
                    },
                    'iframe[title="Company message"]': {
                        display: 'none !important',
                        opacity: '0 !important'
                    },
                    'iframe[title="Message from company"]': {
                        display: 'none !important',
                        opacity: '0 !important'
                    },
                    '#launcher': {
                        display: 'none'
                    }
                }}
            />
            {isWebView ?
                handleSwitchWebView(typePage)
                :
                handleSwitchDefault(typePage)
            }
        </>
    );
}

export default ParseWebView;